module.exports = __webpack_public_path__ + "images/category_lp/alcohol/point3_d91884f25291b2f88dac7ae40bb00b78.png";